import { render, staticRenderFns } from "./SimpleCustomerResultMail.vue?vue&type=template&id=7e1cd6b1&scoped=true&"
import script from "./SimpleCustomerResultMail.vue?vue&type=script&lang=js&"
export * from "./SimpleCustomerResultMail.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCustomerResultMail.vue?vue&type=style&index=0&id=7e1cd6b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1cd6b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
